module.exports = __webpack_public_path__ + "img/bg-accident-item-4.57c7047d.png";